import { AdaptiveDpr, Loader, Preload, Stats, useContextBridge, useProgress } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { Suspense, useEffect, useRef, useState } from "react";
import { ScreenCtx, useScreen } from '../../../context/ScreenCtx';
import Content from '../Content/Content'

import css from './flexStyles.css'

function FlexCanvas() {
  const [mouse, setMouse] = useState();  
  const CtxBridge = useContextBridge(ScreenCtx);
  const {pages, setPages, top, setTop} = useScreen();
  const scrollRef = useRef();
  const handleScroll = (e) => (setTop(e.target.scrollTop));
  useEffect(() => void handleScroll({ target: scrollRef.current }), [])

  

  return (
    <>
      <Suspense fallback={<Loader />}>
        <Canvas
          gl={{ alpha: false }}
          style={{height: '100vh'}}
          frameloop='demand'
          mode="concurrent"
        >
          <CtxBridge>
            <AdaptiveDpr pixelated/>
            <Preload all />
            <pointLight position={[-10, -10, -10]} intensity={1} castShadow/>
            <ambientLight intensity={0.1} />
            {/* <LinkBox /> */}
            <Content onReflow={setPages}/>
            <Stats />
          </CtxBridge>
        </Canvas>
      </Suspense>
      <div
        className={css.scrollArea}
        ref={scrollRef}
        onScroll={handleScroll}
        onPointerMove={(e) => (setMouse[(e.clientX / window.innerWidth) * 2 - 1, (e.clientY / window.innerHeight) * 2 - 1])}>
        <div style={{ height: `${pages * 100}vh` }} />
      </div>
  </>
  );
};

export default FlexCanvas;